const mapGrowthSubscriptionsToProduct = (subscriptions) => {
  return subscriptions.map((sub) => {
    const subMedia = sub.medias?.find((media) => media.isThumbnail);

    return {
      productId: sub.id,
      brand: sub.brandName || '',
      name: sub.name || '',
      quantity: sub.quantity || 1,
      cadenceType: sub.cadence,
      url: subMedia?.url || '',
      replenishmentPrice: sub.price || 0,
      retailPrice: sub.msrp || 0,
      price: sub.price || 0,
      description: sub.shortDescription || '',
      nextRenewalDate: sub.nextBillDate,
      isActive: sub.active && !sub.nonrenew,
      isCancelled: sub.cancelled,
      liveInCampaignType: null,
      subscriptionLimit: sub.subscriptionLimit,
    };
  });
};

export default mapGrowthSubscriptionsToProduct;
